
  import { computed, defineComponent } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  export default defineComponent({
    name: 'BaseEmpty',
    emits: ['refresh'],
    setup(props, { emit }) {
      const router = useRouter();
      const route = useRoute();
      function handleBack() {
        router.back();
      }
      function handleRefresh() {
        emit('refresh');
      }
      const isRealHide = computed(() => route.query.f == 'wx');
      return {
        handleBack,
        handleRefresh,
        isRealHide,
      };
    },
  });
